module.exports = __webpack_public_path__ + "img/home-portfolio-noise.png?121fbdd72181754c9ac51f02d7aea8ef";